module.exports = __webpack_public_path__ + "static/media/info-square.6c06028f.svg";